export default "__VITE_ASSET__Bzo9$rVo__"